export var ReportState = {
    NORMAL: 0,
    INTERMEDIATE: 1,
    REPORTED: 2,
};

const data = [
    [
        {
            label: "I'm not sure if people really want me around them. I think that I am really annoying to them and I suspect they might be talking behind my back.",
            relatable: false,
            reported: ReportState.NORMAL
        },
        {
            label: "im worthless and stupid",
            relatable: false,
            reported: ReportState.NORMAL
        },
        {
            label: "Feelings of isolation, dread, loneliness.",
            relatable: false,
            reported: ReportState.NORMAL
        },
        {
            label: "I'm not enough. That I'm worthless",
            relatable: false,
            reported: ReportState.NORMAL
        },
        {
            label: "Everyone hates me, I’ll never be good enough. I’m everyone’s last option",
            relatable: false,
            reported: ReportState.NORMAL
        }
    ],
    [
        {
            label: "I never had an actual friend until the 5th grade and never had a friend group until the 7th grade. I looked back on my past self and thought I was really annoying and that's why people didn't like to be around me or want to be my friend. I also moved schools and started new so I had a little bit of confidence. My ex-best friend went behind my back and told her mother that I was \"gay\" and told her other things that I didn't want others to know.",
            relatable: false,
            reported: ReportState.NORMAL
        },
        {
            label: "being around much smarter people they probably hand out with me for pity",
            relatable: false,
            reported: ReportState.NORMAL
        },
        {
            label: "I want to know too. I have trouble feeling a sense of safety. I often just need a lot of reassurance. My self doubt and self loathing might also play a role. But not sure from where",
            relatable: false,
            reported: ReportState.NORMAL
        },
        {
            label: "Not sure. Started around 10 years ago",
            relatable: false,
            reported: ReportState.NORMAL
        },
        {
            label: "My parents always put me last, my first relationship was extremely abusive mentally",
            relatable: false,
            reported: ReportState.NORMAL
        }
    ],
    [
        {
            label: "I would hug them, I'm a better listener than an advice giver.",
            relatable: false,
            reported: ReportState.NORMAL
        },
        {
            label: "we love and aupport you you are more than you think, your funny amazingly talented smart and creative.",
            relatable: false,
            reported: ReportState.NORMAL
        },
        {
            label: "I’ll be here for you. I’ll accompany you, tell me anything on your mind. Being scared is normal, I know you can get through.",
            relatable: false,
            reported: ReportState.NORMAL
        },
        {
            label: "That it's ok to feel this. That they are worth the world and I will be here until you feel the same",
            relatable: false,
            reported: ReportState.NORMAL
        },
        {
            label: "You’re Amazing in every aspect. I’m proud of you and everything you’ve accomplished",
            relatable: false,
            reported: ReportState.NORMAL
        }
    ],
    [
        {
            label: "I need to let go of the fact that not everybody is watching me and that the people around me won't remember what I did come next week.",
            relatable: false,
            reported: ReportState.NORMAL
        },
        {
            label: "that this is a hard school and i am not the only one struggling. everyone just shows it differently",
            relatable: false,
            reported: ReportState.NORMAL
        },
        {
            label: "I’ll find someway to cope",
            relatable: false,
            reported: ReportState.NORMAL
        },
        {
            label: "That it's all going to be OK one day. I just need to make it until that day",
            relatable: false,
            reported: ReportState.NORMAL
        },
        {
            label: "I need to learn to love myself. I need to learn to let go of the past. I need to learn how to let people in",
            relatable: false,
            reported: ReportState.NORMAL
        }
    ]
];

export default data;

